export default function AttachFindingReportFolderDirective() {
  return {
    template: require('./attach-finding-report-folder.html'),
    scope: {
      findingId: '=',
      serviceId: '=',
      reportFolder: '=',
    },
    controller: 'AttachFindingReportFolderController',
    controllerAs: 'attachFindingReportFolderVM',
    bindToController: true,
    replace: true
  };
}
